<template>
	<h2>Javier Dur&aacute;n</h2>
	<br>
	<h3>Desarrollador de software</h3>
	<br>
	<h3>En construcción</h3>
  	Esta es mi página contacto público, se encuentra en construcción disculpa las molestias <br>
  	puedes contatarme al correo electrónico <a href="mailto:jduran@alejadur.cl">jduran@alejadur.cl</a>
</template>